export default {
  tabs: {
    home: 'Acasă',
    menu: 'Meniu',
    orders: 'Comenzi',
  },
};
